import { render, staticRenderFns } from "./JpaPaging.vue?vue&type=template&id=bb791578"
import script from "./JpaPaging.vue?vue&type=script&lang=js"
export * from "./JpaPaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports